module.exports = __webpack_public_path__ + "static/media/firebase.f17fe5b6.svg";